import React from 'react';
import Toast from './Toast';
import TeXiao from './TeXiao';
import Alert, { IActionInfo } from './Alert';
import autobind from 'autobind-decorator';

let seed = 0;
const now = Date.now();

const guid = () => {
    return `notification_${now}_${seed++}`;
};

class Notification extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            toast: new Array(),
            TeXiao: new Array(),
            alert: new Array()
        };
    }

    toast(text: any, duration: number = 1500, mask: boolean = false) {
        this.setState({
            toast: [
                {text, duration, mask, id: guid()}
            ]
        });
    }

    TeXiao(text: any, duration: number = 1000, mask: boolean = false) {
        this.setState({
            TeXiao: [
                {text, duration, mask, id: guid()}
            ]
        });
    }

    alert(text: any, actions: IActionInfo[], msg?: any) {
        this.setState({
            alert: [
                {text, id: guid(), actions, msg}
            ]
        });
    }

    hasMask() {
        if (this.state.alert.length > 0) {
            return true;
        }
        return this.state.toast.some((item) => item.mask);
    }

    @autobind
    onClose(id, type) {
        if (type == 'toast') {
            this.setState({
                toast: this.state.toast.filter(item => item.id != id)
            });
        } else if (type == 'alert') {
            this.setState({
                alert: this.state.alert.filter(item => item.id != id)
            });
        } else if (type == 'TeXiao') {
            this.setState({
                TeXiao: this.state.TeXiao.filter(item => item.id != id)
            });
        }
    }

    render() {
        return <div>
            {this.state.toast.map((item: any) => {
                return <Toast key={item.id} info={item} onClose={this.onClose}/>;
            })}
            {this.state.TeXiao.map((item: any) => {
                return <TeXiao key={item.id} info={item} onClose={this.onClose}/>;
            })}
            {this.state.alert.map((item: any) => {
                return <Alert key={item.id} info={item} onClose={this.onClose}/>;
            })}
        </div>;
    }
}

export default Notification;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/notice/Notification.tsx